import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ItemsPerSize, OrderableSpecialStepAlternativeItem, Utils, SizePrice, ConfigService, StoreConfig } from 'ngx-web-api';
import { ItemEditorService } from '../../core/services/item-editor.service';
import { MenuWrapperService } from '../../core/services/menu-wrapper.service';
import { SpecialWizardStep } from '../../domain/special-wizard-step';
import { OrderingUtilsService } from 'app/core/services/ordering-utils.service';

@Component({
  selector: 'fts-special-wizard-item-selector-entry',
  templateUrl: './special-wizard-item-selector-entry.component.html',
  styleUrls: ['./special-wizard-item-selector-entry.component.scss'],
})
export class SpecialWizardItemSelectorEntryComponent implements OnInit, OnChanges {
  @Input()
  item: OrderableSpecialStepAlternativeItem;
  @Input()
  currentStep: SpecialWizardStep;
  @Output()
  itemSelected: EventEmitter<boolean> = new EventEmitter<boolean>();

  calories: string;

  surcharge: number;

  selectedSizePrice?: SizePrice;
  formattedNoticePeriod: string = '';
  hasCateringNoticeTime: boolean;

  constructor(
    private menuService: MenuWrapperService,
    private itemEditorService: ItemEditorService,
    private orderingUtillsService: OrderingUtilsService,
    private configService: ConfigService
  ) {}

  getSurchargeBySizeAndItemLabel(selectedSize: string, itemLabel: string) {
    type ItemsPerSizeWithSurcharge = ItemsPerSize & { surcharge: number };
    const sizeSurcharges: Array<any> = Utils.flatten(this.currentStep.stepAlternatives.map(sa => Utils.flatten(sa.sizeSurcharges)));
    const allItemsPerSizeWithSurcharge: ItemsPerSizeWithSurcharge[] = sizeSurcharges.reduce<ItemsPerSizeWithSurcharge[]>((p, c, _i, []) => {
      const itemsPerSizeWithSurcharge = c.itemsPerSize.map(is => ({ items: is.items, size: is.size, surcharge: c.surcharge }));
      return [...p.concat(itemsPerSizeWithSurcharge)];
    }, []);
    const match = allItemsPerSizeWithSurcharge?.find(ips => ips.size === selectedSize && !!ips.items.find(label => itemLabel === label));
    this.surcharge = match?.surcharge || 0;
  }

  ngOnInit(): void {
    this.configService.storeConfig$.subscribe((store: StoreConfig) => (this.hasCateringNoticeTime = store?.hasCateringNoticeTime));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['item']) {
      this.selectedSizePrice = this.menuService.getDefaultSizePrice(this.item.availableSizePrices);
      if (this.selectedSizePrice) {
        this.formattedNoticePeriod = this.orderingUtillsService.formatNoticePeriod(this.selectedSizePrice?.noticePeriod);
        this.item.selectedSize = this.selectedSizePrice.size;
        this.getSurchargeBySizeAndItemLabel(this.selectedSizePrice.size, this.item.label);
      }
      this.calcCalories();
    }
  }

  onItemSelected(isCustomizing: boolean) {
    this.itemSelected.emit(isCustomizing);
    this.itemEditorService.updateEditingItem(this.currentStep.selectedOrderableItem, this.currentStep.selectedOrderedItem);
  }

  onSizeSelected(size: string) {
    this.selectedSizePrice = this.item.availableSizePrices.find(s => s.size === size);
    this.formattedNoticePeriod = this.orderingUtillsService.formatNoticePeriod(this.selectedSizePrice?.noticePeriod);
    this.calcCalories();
    this.getSurchargeBySizeAndItemLabel(this.selectedSizePrice.size, this.item.label);
  }

  private calcCalories(): void {
    this.calories = this.menuService.getItemCalories(this.selectedSizePrice, this.item.showFullSizeCalories);
  }
}
